import type React from "react";
import { Suspense, createContext, lazy, useState } from "react";

const TutorialPerson = lazy(() => import("../components/TutorialPerson"));

export interface TutorialContextProps {
  showTutorial: (
    type: "token" | "default",
    text: JSX.Element,
    bottom?: string,
    yPosText?: string,
    yPosCloud?: string,
  ) => void;
  hideTutorial: () => void;
}

export const TutorialContext = createContext<TutorialContextProps | undefined>(
  undefined,
);

export const TutorialProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [tutorial, setTutorial] = useState<{
    type: "token" | "default";
    text: JSX.Element;
    bottom?: string;
    yPosText?: string;
    yPosCloud?: string;
  } | null>(null);

  const showTutorial = (
    type: "token" | "default",
    text: JSX.Element,
    bottom?: string,
    yPosText?: string,
    yPosCloud?: string,
  ) => {
    setTutorial({ type, text, bottom, yPosText, yPosCloud });
  };

  const hideTutorial = () => {
    setTutorial(null);
  };

  return (
    <TutorialContext.Provider value={{ showTutorial, hideTutorial }}>
      {children}
      {tutorial && (
        <Suspense fallback={null}>
          <TutorialPerson
            type={tutorial.type}
            text={tutorial.text}
            bottom={tutorial.bottom}
            yPosText={tutorial.yPosText}
            yPosCloud={tutorial.yPosCloud}
          />
        </Suspense>
      )}
    </TutorialContext.Provider>
  );
};
